// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/payments/firstparty/v5/search_payments.proto

/* oxlint-disable */
import { ApiPaginationInput, ApiPaginationMeta } from "../../../../../common/pagination";
import { ApiPayment, ApiPaymentStatus, apiPaymentStatusFromJSON, apiPaymentStatusToJSON } from "./payment";

/** Message for search payments request */
export interface ApiSearchPaymentsRequest {
  /** Filters parameters (optional) */
  readonly filters?:
    | ApiSearchPaymentsRequestFilters
    | null
    | undefined;
  /** Pagination parameters (optional) */
  readonly paginationInput?:
    | ApiPaginationInput
    | null
    | undefined;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by settled_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  readonly sortField: readonly ApiSearchPaymentsRequestSortField[];
}

/** Enum for sort fields for search payments request */
export const ApiSearchPaymentsRequestSortField = {
  /** SORT_FIELD_UNSPECIFIED - Default unspecified value for unknown or unrecognized sort field */
  SORT_FIELD_UNSPECIFIED: "SORT_FIELD_UNSPECIFIED",
  /** SORT_FIELD_SETTLED_AT_ASC - Sort by settled at ASC */
  SORT_FIELD_SETTLED_AT_ASC: "SORT_FIELD_SETTLED_AT_ASC",
  /** SORT_FIELD_SETTLED_AT_DESC - Sort by settled at DESC */
  SORT_FIELD_SETTLED_AT_DESC: "SORT_FIELD_SETTLED_AT_DESC",
} as const;

export type ApiSearchPaymentsRequestSortField =
  typeof ApiSearchPaymentsRequestSortField[keyof typeof ApiSearchPaymentsRequestSortField];

export namespace ApiSearchPaymentsRequestSortField {
  export type SORT_FIELD_UNSPECIFIED = typeof ApiSearchPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
  export type SORT_FIELD_SETTLED_AT_ASC = typeof ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_ASC;
  export type SORT_FIELD_SETTLED_AT_DESC = typeof ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_DESC;
}

export function apiSearchPaymentsRequestSortFieldFromJSON(object: any): ApiSearchPaymentsRequestSortField {
  switch (object) {
    case 0:
    case "SORT_FIELD_UNSPECIFIED":
      return ApiSearchPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
    case 1:
    case "SORT_FIELD_SETTLED_AT_ASC":
      return ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_ASC;
    case 2:
    case "SORT_FIELD_SETTLED_AT_DESC":
      return ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_DESC;
    default:
      return ApiSearchPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
  }
}

export function apiSearchPaymentsRequestSortFieldToJSON(object: ApiSearchPaymentsRequestSortField): string {
  switch (object) {
    case ApiSearchPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED:
      return "SORT_FIELD_UNSPECIFIED";
    case ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_ASC:
      return "SORT_FIELD_SETTLED_AT_ASC";
    case ApiSearchPaymentsRequestSortField.SORT_FIELD_SETTLED_AT_DESC:
      return "SORT_FIELD_SETTLED_AT_DESC";
    default:
      return "SORT_FIELD_UNSPECIFIED";
  }
}

/** Message for search payments filter parameters */
export interface ApiSearchPaymentsRequestFilters {
  /**
   * Filter by payment status - array of statuses.
   * only allowed values are PAYMENT_STATUS_PROCESSING and PAYMENT_STATUS_COMPLETED.
   * The absence of value, will return both PAYMENT_STATUS_PROCESSING and PAYMENT_STATUS_COMPLETED payments.
   */
  readonly status: readonly ApiPaymentStatus[];
}

/** Message for search payments response */
export interface ApiSearchPaymentsResponse {
  /** The list of payments. */
  readonly payments: readonly ApiPayment[];
  /** Pagination metadata. */
  readonly pagination: ApiPaginationMeta | null;
}

export const ApiSearchPaymentsRequest: MessageFns<ApiSearchPaymentsRequest> = {
  fromJSON(object: any): ApiSearchPaymentsRequest {
    return {
      filters: isSet(object.filters) ? ApiSearchPaymentsRequestFilters.fromJSON(object.filters) : null,
      paginationInput: isSet(object.pagination_input) ? ApiPaginationInput.fromJSON(object.pagination_input) : null,
      sortField: globalThis.Array.isArray(object?.sort_field)
        ? object.sort_field.map((e: any) => apiSearchPaymentsRequestSortFieldFromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiSearchPaymentsRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined && message.filters !== null) {
      obj.filters = ApiSearchPaymentsRequestFilters.toJSON(message.filters);
    }
    if (message.paginationInput !== undefined && message.paginationInput !== null) {
      obj.pagination_input = ApiPaginationInput.toJSON(message.paginationInput);
    }
    if (message.sortField?.length) {
      obj.sort_field = message.sortField.map((e) => apiSearchPaymentsRequestSortFieldToJSON(e));
    }
    return obj;
  },
};

export const ApiSearchPaymentsRequestFilters: MessageFns<ApiSearchPaymentsRequestFilters> = {
  fromJSON(object: any): ApiSearchPaymentsRequestFilters {
    return {
      status: globalThis.Array.isArray(object?.status)
        ? object.status.map((e: any) => apiPaymentStatusFromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiSearchPaymentsRequestFilters): unknown {
    const obj: any = {};
    if (message.status?.length) {
      obj.status = message.status.map((e) => apiPaymentStatusToJSON(e));
    }
    return obj;
  },
};

export const ApiSearchPaymentsResponse: MessageFns<ApiSearchPaymentsResponse> = {
  fromJSON(object: any): ApiSearchPaymentsResponse {
    return {
      payments: globalThis.Array.isArray(object?.payments)
        ? object.payments.map((e: any) => ApiPayment.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? ApiPaginationMeta.fromJSON(object.pagination) : null,
    };
  },

  toJSON(message: ApiSearchPaymentsResponse): unknown {
    const obj: any = {};
    if (message.payments?.length) {
      obj.payments = message.payments.map((e) => ApiPayment.toJSON(e));
    }
    if (message.pagination !== undefined && message.pagination !== null) {
      obj.pagination = ApiPaginationMeta.toJSON(message.pagination);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
